module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.assignments), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "assignment",
      class: [_vm.isBlock ? 'block' : 'inline'],
      on: {
        "click": function($event) {
          return _vm.openAssignmentViewer(value.viewer_url)
        }
      }
    }, [_c('div', {
      staticClass: "assignment-cover-container"
    }, [_c('img', {
      staticClass: "assignment-cover",
      attrs: {
        "src": value.assigned_card.cover_image,
        "alt": "cover"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "assignment-gradient"
    })]), _vm._v(" "), _c('div', {
      staticClass: "assignment-description"
    }, [_c('img', {
      staticClass: "assignment-profile",
      attrs: {
        "src": value.assigned_by_profile_image,
        "alt": "profile-image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "assignment-title"
    }, [_vm._v(_vm._s(value.assigned_card.title))]), _vm._v(" "), _c('div', {
      staticClass: "assignment-subtitle"
    }, [_vm._v(_vm._s(value.assigned_card.grade_name) + " " + _vm._s(value.assigned_card.subject_name) + " " + _vm._s(value.assigned_card.chapter_name))])]), _vm._v(" "), _c('div', {
      staticClass: "assignment-date",
      style: ({
        'color': _vm.dueDate(value.due_date).color
      })
    }, [(_vm.remainingDay(value.due_date)) ? _c('strong', [_vm._v("D-" + _vm._s(_vm.remainingDay(value.due_date)))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.dueDate(value.due_date).dueDate) + "\n    ")]), _vm._v(" "), (_vm.isBlock) ? _c('div', {
      staticClass: "assignment-state"
    }, [(_vm.isDueDate(value.due_date) && !_vm.isSubmitted(value.submissions)) ? _c('div', {
      staticClass: "assignment-state-active"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('assignment.assignment_solve')) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.isGraded(value.submissions) && _vm.isSubmitted(value.submissions)) ? _c('div', {
      staticClass: "assignment-state-graded"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('assignment.stats.in_review_count')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isGraded(value.submissions) && _vm.isSubmitted(value.submissions)) ? _c('div', {
      staticClass: "assignment-state-score"
    }, [
      [_vm._v(_vm._s(_vm.$t('assignment.user')) + " "), _c('span', [_vm._v(_vm._s(_vm.userScore(value)))]), _vm._v(_vm._s(_vm.$t('common.score_value')))], _vm._v(" "), [_vm._v(_vm._s(_vm.$t('assignment.class')) + " "), _c('span', [_vm._v(_vm._s(_vm.classScore(value)))]), _vm._v(_vm._s(_vm.$t('common.score_value')))]
    ], 2) : _vm._e(), _vm._v(" "), (!_vm.isDueDate(value.due_date) && !_vm.isSubmitted(value.submissions)) ? _c('div', {
      staticClass: "assignment-state-score"
    }, [
      [_vm._v(_vm._s(_vm.$t('assignment.non_submission')))], _vm._v(" "), [_vm._v(_vm._s(_vm.$t('assignment.class')) + " "), _c('span', [_vm._v(_vm._s(_vm.classScore(value)))]), _vm._v(_vm._s(_vm.$t('common.score_value')))]
    ], 2) : _vm._e()]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb205c48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/Assignment.vue
// module id = 1606
// module chunks = 1